import { createAction } from '@reduxjs/toolkit';
import { SaveModerationFiltersPayload } from './moderationFiltersTypes';

export const fetchModerationFiltersConfigs = createAction<string>(
  'moderationFilters/FETCH_MODERATION_FILTERS_CONFIGS'
);

export const saveModerationFiltersConfigs = createAction<SaveModerationFiltersPayload>(
  'moderationFilters/SAVE_MODERATION_FILTERS_CONFIGS'
);
